import {useState, useEffect, useMemo} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {createSCAPIFetch} from '../utills/customFetch'

const useCustomFetch = (token, ids, isSlot = true) => {
    const [response, setResponse] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const {app: appConfig} = getConfig()

    const slotParams = useMemo(
        () => (isSlot ? `c_contentSlotIDs=${ids}` : `c_contentAssetIDs=${ids}`),
        [ids, isSlot]
    )

    useEffect(() => {
        if (!token || ids === null) return

        const fetchData = async () => {
            setLoading(true)
            setError(null)

            const args = [
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Authorization: `Bearer ${token}`
                    }
                }
            ]

            try {
                const customFetch = createSCAPIFetch(appConfig, 'custom/get-content', slotParams)
                const result = await customFetch('contents', 'GET', args)
                const htmlRes = await result.text()
                setResponse(htmlRes)
            } catch (err) {
                console.error('Error in fetching custom API:', err)
                setError(err.message || 'An unexpected error occurred')
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [token, slotParams, appConfig])

    return {response, loading, error}
}

export default useCustomFetch
